// custom typefaces
import "@fontsource-variable/montserrat";
import "@fontsource/merriweather";
// normalize CSS across browsers
import "./src/normalize.css";
// custom CSS styles
import "./src/style.css";
import "./src/saas.css";

// Highlighting for code blocks
import "prismjs/themes/prism.css";

// Tailwind
import "./src/global.css";

import React from "react";
import CookieNotice from "./src/components/CookieNotice";
import { loadSmartlook, getRecordingConsent } from "./src/utils/tracking";

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieNotice />
  </>
);

export const onClientEntry = () => {
  // Google Ads tag is loaded by gatsby-plugin-google-gtag (see gatsby-config.js).
  // Consent defaults are set via the inline script in gatsby-ssr.js.

  // Smartlook loads only with explicit recording consent (CIPA opt-in).
  if (getRecordingConsent() === "accepted") {
    loadSmartlook();
  }
};

// export const onRouteUpdate = loc => {
//   const { state } = loc.location;

//   if (state && state.refocusId) {
//     const elem = document.getElementById(state.refocusId);

//     if (elem) {
//       elem.focus();
//     }
//   }
// };
